import { render, staticRenderFns } from "./PersistAuditoriaView.vue?vue&type=template&id=b4c888e8&"
import script from "./PersistAuditoriaView.vue?vue&type=script&lang=ts&"
export * from "./PersistAuditoriaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports